import { render, staticRenderFns } from "./monitoring-note.vue?vue&type=template&id=3aa0d30e&scoped=true&"
import script from "./monitoring-note.vue?vue&type=script&lang=js&"
export * from "./monitoring-note.vue?vue&type=script&lang=js&"
import style0 from "./monitoring-note.vue?vue&type=style&index=0&id=3aa0d30e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa0d30e",
  null
  
)

export default component.exports